var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcCabCapsuleFileVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.9,
    y: 9.9,
    width: 22.2,
    height: 20.2,
    rx: 4.5,
    stroke: "#FFFFFF",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1 13.4V26.6C35.1 27.6 34 28.2 33.2 27.6L28.1 24.1V15.9L33.2 12.4C34 11.8 35.1 12.4 35.1 13.4Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 16.4L19.4 19.7C19.8 19.9 19.8 20.5 19.4 20.7L13.6 24C13.2 24.2 12.8 23.9 12.8 23.5V16.9C12.8 16.5 13.2 16.2 13.6 16.4Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcCabCapsuleFileVideoIcon);
export default __webpack_public_path__ + "static/media/tc_cab_capsule_file_video_icon.42228b2a219285b3c315880cd5e63f07.svg";
export { ForwardRef as ReactComponent };